import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import {
  PaymentsMessagingService,
  PaymentsResult,
  PaymentsResultStatus,
} from '@freelancer/payments-messaging';
import { BannerAlertType } from '@freelancer/ui/banner-alert';
import * as Rx from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { DepositContext } from '../types';

@Component({
  selector: 'app-payments-banners',
  template: `
    <!-- notification on initialization -->
    <ng-container *ngIf="depositContext$ | flAsync as depositContext">
      <app-notification-template
        *ngIf="depositContext.banner && depositContext.banner.body"
        [message]="depositContext.banner.body"
        [cta]="depositContext.banner.cancelBtnText"
        [ctaLink]="depositContext.banner.cancelUrl"
        [notificationType]="BannerAlertType.INFO"
      ></app-notification-template>
    </ng-container>
    <!-- notification for pending deposits -->
    <app-notification-template
      *ngIf="pending$ | flAsync as pending"
      [header]="'Thank you! Your payment is pending.'"
      [message]="pending.paymentsMessage"
      [cta]="pending.cta"
      [ctaLink]="pending.ctaLink"
      [notificationType]="BannerAlertType.INFO"
    ></app-notification-template>

    <!-- notification on errors -->
    <app-error-template> </app-error-template>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentsBannersComponent implements OnInit {
  BannerAlertType = BannerAlertType;

  pending$: Rx.Observable<PaymentsResult>;

  @Input() depositContext$: Rx.Observable<DepositContext>; // TODO: replace with banner only

  constructor(
    private paymentsMessaging: PaymentsMessagingService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    const results$ = this.paymentsMessaging.getResultStream();

    this.pending$ = results$.pipe(
      filter(result => result.paymentsStatus === PaymentsResultStatus.PENDING),
      tap(() => this.cdr.detectChanges()),
    );
  }
}
